import { Link } from "react-router-dom";

const ThePipsInsightsContentTwo = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row reverse-mobile">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/the_pips_insights/resources_insights_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h2>Turning Data Into Direction</h2>
              <p>
                Markets move fast but informed traders move faster. At The Pips
                Insights, we turn complex analytics into meaningful stories,
                helping you understand not just where the markets are, but where
                they’re heading next. From macroeconomic shifts and global
                policy changes to asset correlations and market sentiment, our
                articles, reports, and visual data briefs give you a holistic
                understanding of what truly drives the financial landscape. Each
                insight is crafted to highlight opportunities and potential
                risks before they unfold. With clear, concise, and actionable
                analysis, you can navigate the markets with greater confidence
                and precision.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/register"}
              >
                Register now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThePipsInsightsContentTwo;
